import React from 'react';


class Arrows extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'Arrows';

    // bind functions to component
    this.onUpArrowClick = this.onUpArrowClick.bind(this);
    this.onDownArrowClick = this.onDownArrowClick.bind(this);
    this.renderUpArrowSvg = this.renderUpArrowSvg.bind(this);
    this.renderDownArrowSvg = this.renderDownArrowSvg.bind(this);
  }


  /**
   * Click handler for up arrow
   * @returns {ReactElement} ReactElement
   */
  onUpArrowClick() {
    this.props.upArrowHandler();
  }


  /**
   * Click handler for down arrow
   * @returns {ReactElement} ReactElement
   */
  onDownArrowClick() {
    this.props.downArrowHandler();
  }


  /**
   * Renders up arrow svg
   * @returns {String} An svg string
   */
  renderDownArrowSvg() {
    return '<svg fill="#ffffff" height="30" viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"/><path d="M0 0h30v30H0z" fill="none"/></svg>';
  }


  /**
   * Renders down arrow svg
   * @returns {String} An svg string
   */
  renderUpArrowSvg() {
    return '<svg fill="#ffffff" height="30" viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg"><path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"/><path d="M0 0h30v30H0z" fill="none"/></svg>';
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const className = 'component-arrows';

    return (
      <div className={className}>
        <div
          className='arrow up'
          onClick={this.onUpArrowClick}
        >
          <div
            className='icon'
            dangerouslySetInnerHTML={{ __html: this.renderUpArrowSvg() }}
          />
        </div>
        <div
          className='arrow down'
          onClick={this.onDownArrowClick}
        >
          <div
            className='icon'
            dangerouslySetInnerHTML={{ __html: this.renderDownArrowSvg() }}
          />
        </div>
      </div>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Function} upArrowHandler - A function to fire when the up arrow is
 * clicked
 * @prop {Function} downArrowHandler - A function to fire when the down arrow is
 * clicked
 */
Arrows.propTypes = {
  upArrowHandler: React.PropTypes.func,
  downArrowHandler: React.PropTypes.func,
};


export default Arrows;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/Arrows.jsx
 **/